"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SelectLicenseField = _interopRequireDefault(require("./SelectLicenseField"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const SelectLicenseWidget = props => {
  const id = props.id,
        options = props.options,
        value = props.value,
        required = props.required,
        disabled = props.disabled,
        readonly = props.readonly,
        multiple = props.multiple,
        autofocus = props.autofocus,
        onChange = props.onChange,
        onBlur = props.onBlur,
        onFocus = props.onFocus,
        placeholder = props.placeholder;
  const emptyValue = multiple ? [] : "";
  const label = options.title || props.title || props.label;
  const helperText = options.help || undefined;

  const handleChange = (value, event) => {
    onChange(value);
  };

  return _react.default.createElement(_SelectLicenseField.default, {
    id: id,
    placeholder: placeholder,
    multiple: multiple,
    label: label,
    helperText: helperText,
    value: typeof value === "undefined" ? emptyValue : value,
    required: required,
    disabled: disabled || readonly,
    autoFocus: autofocus,
    onChange: handleChange
  });
};

var _default = SelectLicenseWidget;
exports.default = _default;
module.exports = exports.default;